// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from "../core/scenes/BaseScene";
import IntroSequence from "../prefabs/IntroSequence";
import BtnBack from "../core/prefabs/BtnBack";
import UIPositionContainer from "../core/components/UIPositionContainer";
import BtnAudio from "../core/prefabs/BtnAudio";
import BtnSkip from "../prefabs/BtnSkip";
/* START-USER-IMPORTS */
import { app } from '../core/App';
import { TransitionPoint } from '../app-routing';
import UIButton from '../core/components/UIButton';
/* END-USER-IMPORTS */

export default class Intro extends BaseScene {

  constructor() {
    super("Intro");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // sky
    const sky = this.add.image(960, 384, "intro", "bg-intro.png");

    // introSequence
    const introSequence = new IntroSequence(this, 960, 384);
    this.add.existing(introSequence);
    introSequence.visible = true;

    // btnBack
    const btnBack = new BtnBack(this, 72, 76);
    this.add.existing(btnBack);

    // btnAudio
    const btnAudio = new BtnAudio(this, 1854, 76);
    this.add.existing(btnAudio);

    // btnSkip
    const btnSkip = new BtnSkip(this, 1835.5, 683.5);
    this.add.existing(btnSkip);

    // btnBack (components)
    const btnBackUIPositionContainer = new UIPositionContainer(btnBack);
    btnBackUIPositionContainer.offsetX = 24;
    btnBackUIPositionContainer.offsetY = 24;
    btnBackUIPositionContainer.PinLeft = true;
    btnBackUIPositionContainer.PinTop = true;

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    // btnSkip (components)
    const btnSkipUIPositionContainer = new UIPositionContainer(btnSkip);
    btnSkipUIPositionContainer.offsetX = 24;
    btnSkipUIPositionContainer.offsetY = 24;
    btnSkipUIPositionContainer.PinRight = true;
    btnSkipUIPositionContainer.PinToBottom = true;

    this.sky = sky;
    this.introSequence = introSequence;
    this.btnBack = btnBack;
    this.btnAudio = btnAudio;
    this.btnSkip = btnSkip;

    this.events.emit("scene-awake");
  }

  private sky!: Phaser.GameObjects.Image;
  private introSequence!: IntroSequence;
  private btnBack!: BtnBack;
  private btnAudio!: BtnAudio;
  private btnSkip!: BtnSkip;

  /* START-USER-CODE */
  private introEnded: boolean = false;

  public create() {
    this.editorCreate();

    this.btnBack.once(UIButton.events.clicked, this.back, this);
    this.btnSkip.once(UIButton.events.clicked, this.onIntroSequenceFinished, this);
    this.btnSkip.scale = 0;
    this.introSequence.once(IntroSequence.events.SequenceFinished, this.onIntroSequenceFinished, this);

    this.introEnded = false;

    this.zoomIn();
  }

  protected zoomIn() {
    this.sky.scale = 1.1;
    this.add.tween({
      targets: this.sky,
      scale: 1,
      duration: 3100,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: 0
    });

    this.time.addEvent({ delay: 1200, callback: this.startStory, callbackScope: this });
  }

  protected startStory() {
    this.add.tween({
      targets: this.btnSkip,
      scaleX: 1,
      scaleY: 1,
      duration: 400,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: 600
    });

    this.introSequence.showStory();
  }

  protected hideAndUnbindButtons() {
    this.btnBack.off(UIButton.events.clicked, this.back, this);
    this.btnSkip.off(UIButton.events.clicked, this.onIntroSequenceFinished, this);

    this.add.tween({
      targets: [this.btnBack, this.btnSkip],
      scaleX: 0,
      scaleY: 0,
      duration: 400,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }

  protected back() {
    if (!this.introEnded) {
      this.hideAndUnbindButtons();
      app.gotoNextScene(this, TransitionPoint.IntroBack);
    }
  }

  protected onIntroSequenceFinished() {
    this.introEnded = true;

    this.hideAndUnbindButtons();

    app.gotoNextScene(this, TransitionPoint.IntroEnd);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
